
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/1029ff3f-3984-48ef-bfe7-a19b1b30976d.png" 
              alt="PLADUREX" 
              className="h-12 sm:h-14 mb-4 sm:mb-6 brightness-0 invert"
            />
            <p className="text-white/80 text-sm sm:text-[15px] leading-relaxed mb-4 sm:mb-6 max-w-sm">
              Especialistas en <Link to="/servicios" className="text-white hover:text-primary transition-colors underline">instalación de pladur en Barcelona</Link>. Ofrecemos soluciones profesionales para tabiques, trasdosados, falsos techos y aislamientos acústicos y térmicos.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-primary hover:border-primary transition-all duration-300"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-[18px]"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-primary hover:border-primary transition-all duration-300"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-[18px]"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-primary hover:border-primary transition-all duration-300"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-[18px]"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-4 sm:mb-6">
              Navegación
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 text-sm sm:text-[15px] hover:text-white transition-colors duration-300">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-white/80 text-sm sm:text-[15px] hover:text-white transition-colors duration-300">
                  Sobre nosotros
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-white/80 text-sm sm:text-[15px] hover:text-white transition-colors duration-300">
                  Servicios de pladur
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 text-sm sm:text-[15px] hover:text-white transition-colors duration-300">
                  Preguntas frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white/80 text-sm sm:text-[15px] hover:text-white transition-colors duration-300">
                  Contacto y presupuesto
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div>
              <h3 className="text-white/60 text-[11px] sm:text-[12px] uppercase tracking-wider mb-2 sm:mb-3 font-medium">
                Dirección
              </h3>
              <p className="text-white text-sm sm:text-[15px] leading-relaxed break-words">
                Carrer de Garcilaso, 114<br />
                Sant Andreu, 08027 Barcelona
              </p>
            </div>
            <div>
              <h3 className="text-white/60 text-[11px] sm:text-[12px] uppercase tracking-wider mb-2 sm:mb-3 font-medium">
                Teléfono
              </h3>
              <a
                href="tel:+34629501941"
                className="text-white text-base sm:text-[18px] font-bold hover:text-primary transition-colors duration-300 break-all"
              >
                +34 629 501 941
              </a>
            </div>
            <div>
              <h3 className="text-white/60 text-[11px] sm:text-[12px] uppercase tracking-wider mb-2 sm:mb-3 font-medium">
                Horario
              </h3>
              <p className="text-white text-sm sm:text-[15px] leading-relaxed">
                Lunes - Viernes: 08:00 - 18:00<br />
                Sábado: 09:00 - 14:00
              </p>
            </div>
          </div>

          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/7fc680452db9f705aac649e6585671c9.jpg"
              alt="Instalación profesional de pladur"
              className="w-full h-64 sm:h-80 object-cover object-top rounded-xl"
            />
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-xs sm:text-[14px] text-center md:text-left">
            © 2025 PLADUREX. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <Link
              to="/contacto"
              className="text-white/60 text-xs sm:text-[14px] hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              Aviso Legal
            </Link>
            <Link
              to="/contacto"
              className="text-white/60 text-xs sm:text-[14px] hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              Privacidad
            </Link>
            <Link
              to="/contacto"
              className="text-white/60 text-xs sm:text-[14px] hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
